import React, { useState} from "react";
import { EyeIcon, EyeSlashIcon } from "@heroicons/react/24/outline"; // Optional: Use heroicons or other icons
import useLanguageDirection from "../../hooks/useLanguageDirection";

export default function CustomPasswordInput({
  id,
  label,
  placeholder,
  value,
  onChange,
}) {
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const direction = useLanguageDirection();

  const togglePasswordVisibility = () => {
    setPasswordVisible(!isPasswordVisible);
  };
  
  return (
    <div className="relative w-full">
      {/* Arabic Label */}
      {label && (
        <label
          htmlFor={id}
          className="block mb-2 text-sm font-semibold text-gray-700"
        >
          {label}
        </label>
      )}
      <div className="relative" dir={direction === "ltr" ?"rtl" : "ltr"}>
        {/* Password Input Field */}
        <input
          id={id}
          dir={direction}
          type={isPasswordVisible ? "text" : "password"} // Toggle between text and password
          placeholder={placeholder}
          value={value}
          autoComplete="off" 
          onChange={onChange}
          required
          className="w-full px-2 py-2 text-base text-black bg-white border border-gray-300 rounded-lg md:py-3 md:px-5 sm:text-lg placeholder:text-sm sm:placeholder:text-base "
        />
        {/* Toggle Button */}
        <span
          className="absolute inset-y-0 flex items-center px-3 text-gray-700 cursor-pointer"
          onClick={togglePasswordVisibility} 
        >
          {isPasswordVisible ? (
            <EyeSlashIcon className="w-5 h-5" /> // Icon for hidden password
          ) : (
            <EyeIcon className="w-5 h-5" /> // Icon for visible password
          )}
        </span>
      </div>
    </div>
  );
}
